// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"c998eecd","125":"352d101b","395":"43a333d1","398":"d25a05f1","977":"0a712b0a"}[chunkId] + ".chunk.js";
};